































































































































































import Vue from 'vue';
import { Modal, ModalMixin, Message } from 'mycorems-app-shared';
import { recognition } from 'mycorems-app-accounts';
import { QStepper } from 'quasar';
import { ModalElement } from '@/types';
import AppSupportImage from './AppSupportImage.vue';

interface Data {
  step: number,
  stepTitle: object,
}

export default Vue.extend({
  mixins: [ModalMixin],
  props: {
    title: {
      type: String,
      default: 'CM Reports App Support',
    },
    unclosable: {
      type: Boolean,
      default: true,
    },
  },
  data(): Data {
    return {
      step: 1,
      stepTitle: {
        2: 'Main Dashboard',
        3: 'Enter Your  API Key',
        4: 'Select Clients',
        5: 'Free Trial Credits',
        6: 'Settings: Auto Generate Reports',
        7: 'Settings: Report Recipient Notifications',
      },
    };
  },
  computed: {
    isAgency(): boolean {
      return recognition.isAgency();
    },
    isCompany(): boolean {
      return recognition.isCompany();
    },
    isLastStep(): boolean {
      return (this.step === 7);
    },
    modalTitle(): string {
      if (this.stepTitle[this.step]) {
        return `${this.stepTitle[this.step]}`;
      }
      return this.title;
    },
  },
  methods: {
    nextStep(): void {
      if (this.isLastStep) {
        (this.$refs.modal as ModalElement).hide();
      } else {
        (this.$refs.stepper as QStepper).next();
      }
    },
  },
  components: {
    modal: Modal,
    'app-support-image': AppSupportImage,
    message: Message,
  },
});
